var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"decision-icon",class:'decision-icon--' + _vm.suffix},[_c('icon',{staticClass:"decision-icon__icon",attrs:{"icon":_vm.icon,"fixed-width":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }